var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"manualInit":_vm.privilege.init,"manualErr":_vm.privilege.initErr},on:{"reload":_vm.doInit}},[_c('div',[_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }